<template>
  <PopupBox :popup-styles="{ top: 3 }" class="slide-title-wrapper" placement="bottom-start" @visibility-change="handlePopupVisibilityChange">
    <template v-slot:trigger>
      <h2 class="slide-title"><slot /><PopupToggler :is-open="popupVisible" class="ml-2" /></h2>
    </template>
    <template>
      <PopupMenuList :items="items" :selected-item="selectedItem" class="slide-title-menu" />
    </template>
  </PopupBox>
</template>

<script>
import { PopupBox, PopupMenuList, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  mixins: [ popupToggle ],
  components: { PopupBox, PopupToggler, PopupMenuList },
};
</script>

<style lang="scss" scoped>
.slide-title {
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;

  &-wrapper {
    display: inline-block;
  }

  &-menu {
    border: 1px solid #E5E5E7;
    border-radius: 6px;
    padding: 12px 8px;
    box-shadow: 0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A;
  }
}
</style>
